<template>
  <div class="authlanding"></div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'authlanding',
  data() {
    return {
      req: null,
      data: {},
    }
  },
  mounted() {
    if (typeof this.$route.query.code != 'undefined' && this.$route.query.code.trim() !== '') {
      //console.log("== call post ===");
      this.getToken(this.$route.query.code)
    }
  },
  computed: {
    ...mapGetters(['env']),
  },
  components: {},
  methods: {
    getToken(code) {
      //[CALL API: GET SCOPE]
      this.$http
        .post(this.env.VUE_APP_PATH_API + 'auth-token', {
          code: code,
        })
        .then(
          response => {
            let res = response.body
            //console.log('login tmb token' ,res )
            if (res.statusCode == 200) {
              this.getScoped(res.result.token.access_token)
            } else {
              let login = {
                status: 500,
                msg: 'ในการเชื่อมต่อกรุณาลองใหม่อีกครั้งค่ะ token',
                auth_from: 'tmb',
              }
              this.$session.set('error', login)
            }
          },
          response => {
            let login = {
              status: 500,
              msg: 'ในการเชื่อมต่อกรุณาลองใหม่อีกครั้งค่ะ error token',
              auth_from: 'tmb',
            }
            this.$session.set('error', login)
            let routeData = this.$router.resolve({ path: '/' })
            window.open(routeData.href, '_self')
          },
        )
    },
    getScoped(access_token) {
      //[CALL API: GET SCOPE]
      this.$http
        .get(this.env.VUE_APP_PATH_API + 'scope', {
          headers: {
            Authorization: 'Bearer ' + access_token,
            'x-auth-from': 'tmb',
          },
        })
        .then(
          response => {
            let res = response.body
            if (res.statusCode == 200) {
              const { scope, staffInfo } = res.result
              let login = {
                access_token: access_token,
                scoped: scope,
                name: `${staffInfo.adfsFirstname} ${staffInfo.adfsLastname}`,
                email: staffInfo.email,
                auth_from: 'tmb',
                staffInfo: staffInfo,
                loginTime: staffInfo.loginTime,
              }
              this.$session.set('chili', login)
              //console.log(this.$session.get('chili'))
              let routeData = this.$router.resolve({ path: 'home' })
              window.open(routeData.href, '_self')
            }
          },
          response => {
            let res = response.body
            if (res.statusCode == 403) {
              let login = {
                status: 403,
                msg_en: res.message,
                msg: res.msgTh,
                auth_from: 'tmb',
              }
              //this.$session.set('error', login );
              this.$swal({
                title: login.msg,
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
              }).then(result => {
                if (result.value) {
                  //check logout
                  this.$session.destroy()
                  var cookies = document.cookie.split(';')
                  for (var i = 0; i < cookies.length; i++) {
                    var equals = cookies[i].indexOf('=')
                    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
                  }
                  let url = this.env.VUE_APP_TMB_LOGOUT_URL + this.env.VUE_APP_LOCATION
                  window.location.assign(url)
                }
              })
            } else {
              let login = {
                status: res.statusCode,
                msg: res.message,
                auth_from: 'tmb',
              }
              //this.$session.set('error', login );
              this.$swal({
                title: login.msg,
                type: 'warning',
                showCancelButton: false,
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
              }).then(result => {
                if (result.value) {
                  //check logout
                  this.$session.destroy()
                  var cookies = document.cookie.split(';')
                  for (var i = 0; i < cookies.length; i++) {
                    var equals = cookies[i].indexOf('=')
                    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
                  }
                  let url = this.env.VUE_APP_TMB_LOGOUT_URL + this.env.VUE_APP_LOCATION
                  window.location.assign(url)
                }
              })
            }
          },
        )
    },
  },
}
</script>
